module.exports = __webpack_public_path__ + "media/Loops 90 Keys.547e05df.wav";